import {
    GET_INTERVAL_TYPES, INTERVAL_ERROR
} from '../actions/types';


const initialState = { interval_types: [], interval_type: null, loading: true, error: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_INTERVAL_TYPES:
            return {
                ...state,
                interval_types: payload,
                loading: false
            }
        case INTERVAL_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        default:
            return state;
    }

}